import React, { useEffect, useState } from "react";
import { message, Tabs } from "antd";
import { getUserInfo } from "../../../utils";
import AccountsTab from "../../../components/admin/AccountsTab";
import ModelsTab from "../../../components/admin/ModelsTab";
import SystemTab from "../../../components/admin/SystemTab";

const Admin = () => {
  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
    try {
      setUserInfo(await getUserInfo());
    } catch (error) {
      message.error(String(error));
    }
  };

  if (!userInfo) return null;

  const items = [
    { label: "Accounts", key: "Accounts", children: <AccountsTab userInfo={userInfo} /> },
    { label: "Models", key: "Models", children: <ModelsTab /> },
    { label: "System", key: "System", children: <SystemTab /> },
  ];

  return <Tabs items={items} defaultActiveKey="Accounts" />;
};

export default Admin;
